import { cn } from '@/common/utils/cn'
import GeneralSearchTab from '@/features/modelIntegrationCodes/pages/Show/components/GeneralSearchTab'
import SimilarTab from '@/features/modelIntegrationCodes/pages/Show/components/SimilarTab'
import { IntegrationCodeMatch } from '@/features/modelIntegrationCodes/types/suggestedModel.type'
import { Info } from 'lucide-react'

export type ModelsSearchTabValue = 'similar' | 'general'

interface ModelsSearchProps {
  modelIntegrationCodeId?: string
  equipmentId?: string
  activeTab: ModelsSearchTabValue
  onTabChange: (tab: ModelsSearchTabValue) => void
  selectedKey?: string
  onSelect: (model: IntegrationCodeMatch) => void
}

const tabs: { value: ModelsSearchTabValue; label: string }[] = [
  { value: 'similar', label: 'Mais semelhantes' },
  { value: 'general', label: 'Busca geral' },
]

const ModelsSearch = ({
  modelIntegrationCodeId,
  equipmentId,
  activeTab,
  onTabChange,
  selectedKey,
  onSelect,
}: ModelsSearchProps) => {
  return (
    <div className="flex-1 flex flex-col gap-2 min-h-0">
      <div className="flex items-center gap-1 text-[10px] leading-3">
        <Info size={24} className="shrink-0" />
        <div className="flex flex-col flex-1 min-w-0">
          <p className="font-bold leading-3">
            O Modelo possui divergências de informações em nossas integrações e não foi automaticamente associado,
            analise os modelos disponíveis e defina o correto.
          </p>
          <p className="font-light italic leading-3">
            Os equipamentos que iniciaram o cadastro deste modelo estão temporariamente bloqueados e só serão liberados
            após homologação do modelo.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-2 bg-white-100 p-4 rounded-sm flex-1 min-h-0">
        <p className="text-sm font-bold">Modelos</p>

        <div className="flex gap-2 w-full">
          {tabs.map((tab) => (
            <button
              type="button"
              key={tab.value}
              onClick={() => onTabChange(tab.value)}
              className={cn(
                'flex-1 px-1.5 py-2 text-xs border-b transition-colors',
                activeTab === tab.value ? 'border-blue-800' : 'border-border-default',
              )}
              data-testid={`models_tab_${tab.value}`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="flex-1 min-h-0 flex flex-col">
          {activeTab === 'similar' ? (
            <SimilarTab
              modelIntegrationCodeId={modelIntegrationCodeId}
              equipmentId={equipmentId}
              selectedKey={selectedKey}
              onSelect={onSelect}
            />
          ) : (
            <GeneralSearchTab
              modelIntegrationCodeId={modelIntegrationCodeId}
              equipmentId={equipmentId}
              selectedKey={selectedKey}
              onSelect={onSelect}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ModelsSearch
